import { Injectable } from '@angular/core';

/**
 * Service to provide configuration values.
 * This service is used to store configuration values that are used throughout the application.
 */
@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    /**
     * Link to wiki page for new segment creation.
     * This link is used to provide information about how to create new segments.
     */
    newSegmentWikiLink = 'https://artifexmundi.atlassian.net/wiki/x/ZAGRHQ';

    constructor() {}
}
